require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scientastic-1-12-1-1.json") })
        }
      }, "path---scientastic-1-12-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scientastic-1-12-1-1!./.cache/json/scientastic-1-12-1-1.json
// module id = 563
// module chunks = 231608221292675